define([
    'require',
    'jquery',
    'shared.main.screen',
    "wcs.context"
], function (require, $, screenModule, ctx) {
    var self = {}, molLazyPlatformViewer, data = {reRenderMediaGalleryUrl:"VFAjaxMediaGalleryView?requestype=ajax", positionIndicatorOffset: 10}, sticky;

    function hideElement(element) {
        element.style.display = "none";
    }

    function showElement(element) {
        element.style.display = "inline-block";
    }

    function onFullScreen(event){
        var cell = $(event.target.parentElement.parentElement);
        var cellIndex = cell.data('imageIndex');
        molLazyPlatformViewer.loadViewer(cellIndex, true);
        molLazyPlatformViewer.showViewer();
    }
    function onCloseFullScreen(){
        molLazyPlatformViewer.unloadViewer();
        molLazyPlatformViewer.hideViewer();
    }

    // Load the S7 Platform Viewer
    function loadMolLazyPlatformViewer() {
        if(molLazyPlatformViewer && !molLazyPlatformViewer.isLoaded) {
            molLazyPlatformViewer.initViewer(0, fullScreenChange.bind(self));
        }
    }

    function loadAllImages(){
        var $overlays = $('.mol-media-gallery__cell__overlay');
        $overlays.each( function( i, overlay ) {
            var $overlay = $(overlay);
            var imageUrl = $overlay.data('previewImageUri');

            overlay.style.backgroundImage = "url('" + imageUrl + "')";

            getImageSize(imageUrl)
                .then(function (size) {
                    $overlay.data({
                        width: size.width,
                        height: size.height,
                    });
                });
        });
    }

    function getImageSize(imageUrl) {
        var result = new $.Deferred();
        var img = new Image();

        img.onload = function () {
            result.resolve({
                width: img.width,
                height: img.height,
            });
        };
        img.onerror = function () {
            result.reject(new Error('Image failed to load'));
        };
        img.src = imageUrl;

        return result.promise();
    }

    function moveOutImage(event) {
        if (self.ignoreNextMoveOut) {
            return;
        }
        var $parent = $(event.currentTarget);
        var $overlay = $parent.find('.mol-media-gallery__cell__overlay');

        $overlay.removeClass('mol-media-gallery__cell__overlay__animation__show');
        $overlay.addClass('mol-media-gallery__cell__overlay__animation__hide');

    }
    function moveOverImage(event) {
        var $parent = $(event.currentTarget);
        var $overlay = $parent.find('.mol-media-gallery__cell__overlay');
        var overlay = $overlay[0];

        var width = $parent.width();
        var height = $parent.height();
        var overlayWidthMax = $overlay.data('width');
        var overlayHeightMax = $overlay.data('height');

        if (overlayWidthMax && overlayHeightMax) {
            var x = calculateBackgroundPosition(event.offsetX, width, overlayWidthMax);
            var y = calculateBackgroundPosition(event.offsetY, height, overlayHeightMax);

            overlay.style.backgroundPosition = x + "px " + y + "px";
        }

        // Load the S7 Platform Viewer when user hovers over the media gallery for the first time
        loadMolLazyPlatformViewer();

        if(!overlay.style.minHeight || overlay.style.minHeight === '') {
            overlay.style.minHeight = height + "px";
            overlay.style.height = height + "px";
            overlay.style.width = width + "px";
        }

        //Initially the overlay image is not loaded, so a fake moveout event is generated, that should be skipped
        self.ignoreNextMoveOut = overlay.style.display === 'none';

        if (overlayWidthMax && overlayHeightMax) {
            $overlay.addClass('mol-media-gallery__cell__overlay__animation__show');
            $overlay.removeClass('mol-media-gallery__cell__overlay__animation__hide');
        }
    }

    function calculateBackgroundPosition(offset, imageSize, maxSize) {
        var sizeDiff = imageSize - maxSize;
        return offset / imageSize * sizeDiff;
    }

    function setupHoverZoomEvents(){
        self.imagesSelector.on('mousemove', moveOverImage.bind(self));
        self.imagesSelector.on('mouseout', moveOutImage.bind(self));
        // enabling config to click anywhere in the image
        if(self.config.fullScreenEnabled){
        	self.imagesSelector.on('click', onFullScreen.bind(self));
        }
        self.zoomInButton.on('click', onFullScreen.bind(self));
    }

    function handleDotClick(event, ind, isAdditionalOffset){
        var $dotSpan = $(event.currentTarget);
        var index = ind !== undefined  ? ind : $dotSpan.index();

        if (self.$images.length >= index) {
            var $image = $(self.$images[index]);
            var imageOffsetTop = $image.offset().top;
            if (isAdditionalOffset) {
                imageOffsetTop += $image.height();
            }
            else {
                imageOffsetTop -= self.$topNav.height() + self.$topNavPromo.height();
            }
            self.$body.animate({'scrollTop':imageOffsetTop}, 'slow');
        }
    }

    function setupAccordion() {
        if( self.accordionsInitialized ){
            return;
        }
        self.$reviewAccordionHeader = $('.accordion-power-review > .mol-accordion__header');
        self.$mainReviewHeader = $('#pr-container .rating-reviews-loader h3');
        $(self.$mainReviewHeader).prependTo(self.$reviewAccordionHeader);

        self.$drawerTitle = $('.product-details-drawer>.title');
        $('.accordion-espot > .mol-accordion__header > span').first().text(self.$drawerTitle.text());
        self.$drawerTitle.text('');
        self.accordionsInitialized = true;

    }

    function setupDotScroller(){
        self.$images = self.selector.find('.mol-media-gallery__cell');
        self.$dotContainer = $('.mol-position-indicator-container');
        self.$dots = self.$dotContainer.find('.mol-position-indicator-item');
        self.$topNav = $('header.topnav-header');
        self.$topNavPromo =  $('.topnav-promobar-container');
        self.$body = $('body, html');
        self.$dots.on('click', handleDotClick.bind(self));

        self.$navigationButton = $('.mol-scroll-navigation-button');
        if( self.$navigationButton.length > 0 ){
            self.$navigationLabel = self.$navigationButton.find('span').first();
            self.$navigationIcon = self.$navigationButton.find('.mol-scroll-navigation-button--icon');
            var data = self.$navigationLabel.data();
            self.topLabel = data.topLabel;
            self.bottomLabel = data.bottomLabel;
        }
        self.$navigationButton.on('click', handleScrollButtonClick.bind(self));
    }

    function recalculateDotIndicator(isContentReplaced, recalculateMinHeight){

        var scrollTop = $(window).scrollTop();
        var windowHeight = $(window).height();
        var scrollBottom = scrollTop + windowHeight;

        var topNavHeight = self.$topNav.height() ? self.$topNav.height() : 0;
        var galleryContainerTop = self.selector.offset().top;
        var galleryContainerHeight = self.selector.height();
        var galleryContainerBottom = galleryContainerTop + galleryContainerHeight;

        var dotContainerHeight = self.$dotContainer.height();
        var offsetTop = self.selector.offset().top;
        var offsetLeft = self.selector.offset().left - self.config.positionIndicatorOffset; // Since this is a fixed position, need to set proper left offset so it is not overlapping with the container
        var offsetDots = ((windowHeight - (offsetTop + topNavHeight)) / 2) - (dotContainerHeight / 2);
        self.$dotContainer.css('position', 'fixed');
        self.$dotContainer.css('margin-top', offsetDots + 'px');
        self.$dotContainer.css('left', offsetLeft + 'px');

        var activeIndex = 0;
        for (var i = 0; i < self.$images.length; i++) {
            var $image = $(self.$images[i]);

            var diff = ($image.offset().top + self.$topNav.height() + self.$topNavPromo.height()) - scrollTop;
            if (diff > 0) {
                activeIndex = i;
                break;
            }
        }

        self.$dots.removeClass('active');
        $(self.$dots[activeIndex]).addClass('active');

        if (galleryContainerBottom < scrollBottom) {
            if (!isContentReplaced) {
                self.$dotContainer.fadeOut();
            }
            self.isBottom = true;
        } else {
            self.$dotContainer.fadeIn();
            self.isBottom = false;
        }
        toggleNavigationButton(self.isBottom);
        if( recalculateMinHeight ) {
            var height = self.initialMediaHeight || self.$mediaGalleryWrapper.height();
            var amountOfMediaElements = $('.mol-media-gallery__row').length || 1; // Make sure that there is at least one item
            self.$productViewContainer.css('min-height', amountOfMediaElements * height);
        }
    }

    function toggleNavigationButton(isBottom) {
        if(self.$navigationIcon && self.$navigationIcon.length){
            if (isBottom) {
                self.$navigationIcon.addClass('mol-scroll-navigation-button--icon--bottom');
                self.$navigationLabel.html(self.bottomLabel);
    
            } else {
                self.$navigationIcon.removeClass('mol-scroll-navigation-button--icon--bottom');
                self.$navigationLabel.html(self.topLabel);
            }
        }
    }

    function fullScreenChange(isMaximazing) {
        if( !isMaximazing){
            onCloseFullScreen();
        }
    }

    function handleScrollButtonClick(event){
        var index = self.isBottom ? 0 : self.$images.length - 1;
        handleDotClick(event, index, !self.isBottom);
    }

    function unloadSideBar(){
        self.$stickyInner.css('position', 'unset'); // removing sticky when a modal is opened due to the relativity of the parent container
        self.sticky.unloadSideBar();
    }

    function videoPlayPause($event) {
        var video = $event.currentTarget;
        $event.preventDefault();
        $event.stopPropagation();
        if (video.paused) {
            video.play();
        } else {
            video.pause();
        }
    }

    function reInitSticky(fullReInit) {
        if( self.stickyHeight <  self.mainBodyHeight){
            self.sticky.initSideBar(null, fullReInit);
        }
        else{
            self.sticky.unloadSideBar();
        }
    }
    function isContentPresentInMainPanel(){
        return self.$mainPanelWrapper && self.$mainPanelWrapper.find('.section-1').length > 0;
    }
    function init(isReInit) {
        self.selector = $('.mol-media-gallery');
        self.config = $.extend({}, data, self.selector.data('mediaGallery'));
        self.imagesSelector = $('.mol-media-gallery__cell.mol-media-gallery-image-container', self.selector);
        self.zoomInButton = $('.mol-media-gallery__zoom-icon', self.selector);
        var viewer = $('.mol-lazy-platform-viewer');
        if (viewer.length === 0) {
            return;
        }
        self.reRenderUrl = ctx.getURLWithContextRoot(self.config.reRenderMediaGalleryUrl);

        molLazyPlatformViewer = viewer.first().molLazyPlatformViewer().data().molLazyPlatformViewer;

        if (!self.subScription) {
            self.subScription = $.pubsub('subscribe', 'product-form.attr.swatch.click', handleProductFormSwatchClick.bind(self));
        }
        self.$selectionDetails = $('.section-2, .section-3, .section-reviews');
        self.$mainPanelWrapper = $('.main-panel-wrapper');
        self.$mediaGalleryContainer = $('#product-imgs');
        self.$spinViewerContainer = $('[data-spin-container]');
        self.isSpinViewerPresent = self.$spinViewerContainer.length > 0;
        self.$contentBanner = $('.mol-media-gallery__cell__content__banner');
        self.$lastGalleryContainer = $('.mol-media-gallery-image-container:last');
        self.$molVideoPlayPause = $('.mol-video-player-play-pause-on-click');
        self.$productViewContainer = $('.product-views-container');
        self.$mediaGalleryWrapper = $('.mol-media-gallery-image-wrapper');
        self.$sectionReviews = $('.section-reviews');
        for( var i = 1; i <= 4; i++){ // Getting selectors from sections 1-4
            self['$section' + i] = $('.section-' + i);
        }
        var moveReviewSection = self.$sectionReviews
          .eq(0)
          .siblings()
          .is(self.$section2);

        //Events
        if (screenModule.size() === "small") { // Mobile

            // Load the S7 Platform viewer if it has not been loaded yet
            loadMolLazyPlatformViewer();

            molLazyPlatformViewer.loadViewer(0);
            molLazyPlatformViewer.showViewer();
            if (self.sticky) {
                self.sticky.unloadSideBar();
            }

            self.$selectionDetails.removeClass('attached-to-sticky');
            if (self.$stickySelector && self.$stickySelector.find('.section-2').length > 0) { // Move up the section2 and section3
                if(moveReviewSection && self.$sectionReviews.hasClass('section-top')) $(self.$sectionReviews).insertAfter(self.$stickySelector);
                $(self.$section2).insertAfter(self.$stickySelector);
                if(moveReviewSection && !self.$sectionReviews.hasClass('section-top')) $(self.$sectionReviews).insertAfter(self.$stickySelector);
                $(self.$section3).insertAfter(self.$stickySelector);
            }
            if( isContentPresentInMainPanel() ){
                $(self.$section1).insertAfter(self.$mainPanelWrapper);
                $(self.$section4).insertAfter(self.$section3);
            }

            if( self.isSpinViewerPresent && self.isSpinInitialized){
                molLazyPlatformViewer.restoreContainer(self.selector);
                self.isSpinInitialized = false;
            }

            if (self.$contentBanner && self.$contentBanner.length > 0 && self.selector.find('.mol-media-gallery__cell__content__banner').length > 0) {
                self.$contentBanner.prependTo(self.$section4);
            }

        }
        else { //Desktop
            if( !self.config.listViewEnabled){
                setupHoverZoomEvents(); //In desktop the events (zoom on hover, fullscreen click) are registered, which should be not the case in mobile
            }
            else{
                setupDotScroller(); //In desktop - setup the events related with the scrol and dots (carousel functionality)
                if( self.isSpinViewerPresent && !self.isSpinInitialized){
                    molLazyPlatformViewer.moveToContainer(self.$spinViewerContainer);
                    self.isSpinInitialized = true;
                }
            }

            if (molLazyPlatformViewer) {
                molLazyPlatformViewer.hideViewer();
            }
            self.$stickySelector = $('.mol-sticky-sidebar');
            self.sticky =  self.$stickySelector.first().molStickySidebar().data().molStickySidebar;
            self.$stickyInner = $('.mol-sticky-inner-sidebar');

            self.$selectionDetails.addClass('attached-to-sticky');

            if(self.$sectionReviews.hasClass('section-top')){
                $([self.$sectionReviews[0], self.$section2[0], self.$section3[0]]).appendTo(self.$stickyInner);
            }
            else {
                $([self.$section2[0], self.$section3[0]]).appendTo(self.$stickyInner);

                if (moveReviewSection) {
                    self.$section2.after(self.$sectionReviews.eq(0));
                }
            }

            if( !isContentPresentInMainPanel()){
                if( self.$section1.height() < getRealStickyHeight()){ // This is only needed when the height of the main panel is less than the size of the right panel
                    $([self.$section1[0], self.$section4[0]]).appendTo(self.$mainPanelWrapper);
                }
            }

            $('.delivery-information, .find-store-js').on('click',unloadSideBar.bind(self));
            $(document).on('open.fndtn.reveal', '[data-reveal]', unloadSideBar.bind(self));

            $(document).on('closed.fndtn.reveal', '[data-reveal]', function () {
                reInitSticky();
            });

            if (self.$contentBanner && self.$contentBanner.length > 0 && self.$section4.find('.mol-media-gallery__cell__content__banner').length > 0) {
                self.$contentBanner.prependTo(self.$lastGalleryContainer);
            }

            if(!self.subProductView){//Only in desktop subscribe to the power review since only then the sticky is used
                self.subProductView = $.pubsub('subscribe', 'vfdp.wcs.product_reviews.loaded', refreshDimensions.bind(self));
            }
            if( !self.subAccordionChange){
                self.subAccordionChange = $.pubsub('subscribe', 'vfdp.wcs.mol-accordion.change', recalculateTranslate.bind(self));
            }

            if( self.$molVideoPlayPause.length > 0 ){
                self.$molVideoPlayPause.on('click',videoPlayPause.bind(self));
            }

            if( self.config.isVideoPresent && !self.config.useNativeVideo ){
                require(['videojs']);
            }

            refreshDimensions();

            $.pubsub('subscribe', 'window.scroll', function (event, data) {
                if (getRealStickyHeight() !== self.stickyHeight || getRealBodyHeight() !== self.mainBodyHeight ) {
                    refreshDimensions();
                }
                if (self.config.listViewEnabled && screenModule.size() !== "small") {
                    recalculateDotIndicator();
                }
            });
            if( !self.config.listViewEnabled) {
                loadAllImages();
            }
            else {
                recalculateDotIndicator(isReInit, true);
            }
        }

        setupAccordion();

        //When find in store is not present, the add to cart should be 100% width
        if( !$('.find-store-js').length ){
            $('.product-content-form-product-actions-primary').addClass('full-width');
        }
        $.pubsub('publish', 'vfdp.mol-media-gallery.LOADED');

    }

    function recalculateTranslate() {
        if (self.config.listViewEnabled) {
            reInitSticky(true);
        } else if (self.sticky.checkForManualResize()) {
            refreshDimensions();
            self.sticky.recalculateProperBottom();
        }
    }

    function refreshDimensions(){
        self.mainBodyHeight = getRealBodyHeight();
        self.stickyHeight = getRealStickyHeight();
        changeMinHeightSticky();
        reInitSticky();
    }

    function changeMinHeightSticky(){
        self.$stickyInner.css('min-height', self.stickyHeight + 'px');
    }

    function getRealBodyHeight() {	//High maintenance logic: Any new sections added to main body markup will require update here
        return Math.ceil(self.$section1.outerHeight(true) + self.$section4.outerHeight(true));
    }

    function getRealStickyHeight() {	//High maintenance logic: Any new sections added to sticky markup will require update here
    	var stickySectionReviewSize = 0;
    	
    	if($('.mol-sticky-sidebar .section-reviews').length > 0){
    		stickySectionReviewSize = $('.mol-sticky-sidebar .section-reviews').outerHeight(true);
    	}
    	
        return Math.ceil(self.$section2.outerHeight(true) + self.$section3.outerHeight() + stickySectionReviewSize);
    }

    function setupResizeEvent(){
        $.pubsub('subscribe','window.resize.breakpoint',function() {
            init();
        });
    }

    function replaceComponent(html){ //This is used on the color swatch click. Since the media gallery is rendered on the backend, the html is fetched through an ajax call, then the rendered markup will be replaced with the current one
        if (screenModule.size() === "small") { // On mobile active, only the media gallery should be updated (not the platform viewer - to prevent duplication of platform viewer)
            var htmlGallery =  $(html).filter('.mol-media-gallery')[0];
            var htmlIndicator =  $(html).filter('.mol-position-indicator-container')[0];
            if( htmlIndicator ){
                self.$dotContainer.replaceWith(htmlIndicator);
            }
            self.selector.replaceWith(htmlGallery);
        }
        else {
            self.initialMediaHeight = self.$mediaGalleryWrapper.height();
            self.$mediaGalleryContainer.empty();
            self.$mediaGalleryContainer.html(html);
        }
        init(true);
    }

    function handleProductFormSwatchClick(msg, event) {
        var self = this;
        var dataImage = $(event.target).data();
        var colorContainer = $('.attr-color-js');
        var productId = dataImage.productId ? productId = dataImage.productId : colorContainer.first().data('productId');
        var storeId = $('meta[name=storeId]').attr("content");
        var langId = $('meta[name=langId]').attr("content");
        var isUnisex = dataImage.unisex;
        var unisexDepartment = dataImage.unisexDepartment || '';

        var data = {
            partNumber: dataImage.partNumber,
            productId: productId,
            color_identifier: dataImage.variationId,
            storeId: storeId,
            langId: langId,
            isUnisex: isUnisex,
            unisexDepartment: unisexDepartment
        };
        $.ajax({
            url: self.reRenderUrl,
            data: data
        }).done(replaceComponent.bind(self))
            .fail(function(err){
                console.error(err);
            });
    }

    init();
    setupResizeEvent();

    return {init: init, moveOutImage: moveOutImage,
        moveOverImage: moveOverImage, _hideElement: hideElement, _showElement: showElement, config: self.config,
        _calculateBackgroundPosition: calculateBackgroundPosition, _setupDotScroller: setupDotScroller, self: self};
});
